var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 8.5c0-2.486-2.014-4.5-4.5-4.5H8.5A4.499 4.499 0 0 0 4 8.5v5.4c0 2.486 2.014 4.5 4.5 4.5h5.4c2.486 0 4.5-2.014 4.5-4.5zm0 17.6c0-2.486-2.014-4.5-4.5-4.5H8.5A4.499 4.499 0 0 0 4 26.1v5.4C4 33.986 6.014 36 8.5 36h5.4c2.486 0 4.5-2.014 4.5-4.5zm3.2-17.6v5.4c0 2.486 2.014 4.5 4.5 4.5h5.4c2.486 0 4.5-2.014 4.5-4.5V8.5C36 6.014 33.986 4 31.5 4h-5.4a4.499 4.499 0 0 0-4.5 4.5M36 26.1c0-2.486-2.014-4.5-4.5-4.5h-5.4a4.499 4.499 0 0 0-4.5 4.5v5.4c0 2.486 2.014 4.5 4.5 4.5h5.4c2.486 0 4.5-2.014 4.5-4.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grid.0a6ac48c7617d45b193617b8a56bce27.svg";